import { createContext } from "react";
import { UseTableProps } from "src/hooks/useTable";

export interface ContextType extends UseTableProps {}

const defaultContextValues: ContextType = {
	dense: true,
	page: 0,
	setPage: () => {},
	rowsPerPage: 10,
	order: "asc",
	orderBy: "value",
	//
	selected: [],
	setSelected: () => {},
	onSelectRow: () => {},
	onSelectAllRows: () => {},
	//
	onSort: () => {},
	onChangePage: () => {},
	onChangeRowsPerPage: () => {},
	onChangeDense: () => {}
};

export default createContext<ContextType>(defaultContextValues);
